import { Message } from 'element-ui';
import api from '../../api';

const state = {
  lgas: {
    lga1: '',
    lga2: '',
    status: 'draft',
  },
  loading: false,
};

// getters
const getters = {
//   hasLGA2: state => (!!state.lgas.lga2),
};

// mutations
const mutations = {
  removeLGAs(state) {
    state.lgas = {
      lga1: null,
      lga2: null,
      status: 'draft',
    };
  },

  setLGAs(state, { lgas }) {
    state.lgas = lgas;
  },

  loadingHandler(state, status) {
    state.loading = status;
  },
};

// actions
const actions = {
  async fetchLGAs({ commit }) {
    // empty data
    commit('removeLGAs');
    commit('loadingHandler', true);

    try {
      const response = await api.getLGA();
      commit('setLGAs', {
        lgas: response.data,
      });
      return response.data;
    } catch (err) {
      return null;
    } finally {
      commit('loadingHandler', false);
    }
  },

  async updateLGAs({ commit }, lgas) {
    commit('loadingHandler', true);
    let response;
    try {
      response = await api.updateLGA(lgas);

      commit('setLGAs', {
        lgas: response.data,
      });
      return response.data;
    } catch (err) {
      if (err.msg) {
        Message.error(err.msg);
      }
      throw new Error('LGA not saved');
    } finally {
      commit('loadingHandler', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
